import React, { useEffect, useMemo, useRef, } from "react";
import axios from 'axios';
import {Container} from 'semantic-ui-react';
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { format } from 'date-fns';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import { formatRelative } from "date-fns";
import { Form,
  Input,
   } from 'semantic-ui-react';
import "@reach/combobox/styles.css";
import mapStyles from "../../../components/MapsGoogle/mapStyles";
import { Button } from "@mui/material";
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import HomeIcon from '@mui/icons-material/Home';
 
import "@reach/combobox/styles.css";
import TravelExploreIcon from '@mui/icons-material/TravelExplore';




const libraries = ["places"];
const mapContainerStyle = {
  height: "80vh",
  width: "100%",
};
const options = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
  zoom:8,
};
const center = {
  lat: -33.448891,
  lng: -70.669266,
};

const searchOptions = {
  componentRestrictions: {
    country: "Cl"}
}

const orderDetais ={
        "dispacht": {
                        "packageContentID": "",
                        "courierID": "",
                        "originAdressComuna": "",
                        "toAdressPhone": "",
                        "originAdressName": "",
                        "toAdressComent": "",
                        "packageContent": [],
                        "packageContentQuantity": 1,
                        "originAddress": "",
                        "toAddress": "",
                        "toAdressCountry": "",
                        "courierDriverAvatar": "",
                        "dispachtRetirementDate": "",
                        "dispachtDate": "",
                        "dispachtRouteDate": "",
                        "toPropietary": "",
                        "toGeoNumAddressLng": "",
                        "originGeoNumAddressLng": "",
                        "originAdressCity": "",
                        "toCompanyAsignament": "",
                        "packageContentDescripcion": "",
                        "originAdressRegion": "",
                        "toAdressName": "",
                        "originCompanyAsignament": "",
                        "packageContentPrice": 0,
                        "originPropietary": "",
                        "packageCant": "",
                        "originAdressNumAddress": "",
                        "courierDriverLocationLng": 0,
                        "originAdressPhone": "",
                        "originUserName": "",
                        "courierDriverName": "",
                        "toUserEmail": "",
                        "dispachtStatusChange": "",
                        "toUserName": "",
                        "toAdressComuna": "",
                        "packageCode": "",
                        "packageContentnName": "",
                        "courierDriverPhone": "",
                        "dispachtStatusChangeDate": "",
                        "courierStatus": 0,
                        "dispachtCode": "",
                        "originGeoNumAddressLat":"",
                        "dispachtStatusNotes": "",
                        "originAdressComent": "",
                        "courierDriverLocation": {
                            "_latitude": 0,
                            "_longitude": 0,
                        },
                        "toAdressNumAddress": "",
                        "toAdressCity": "",
                        "locations": [],
                        "dispachtCurrentStatus": "",
                        "packageModifiers": [],
                        "toAdressNumAddressTemp": "",
                        "toGeoNumAddressLat": 0,
                        "serviceCourier": "",
                        "toAdressRegion": "",
                        "dispachtDeliveryDate": ""
                    },
        "history" : {
                    "id": "",
                    "dispachtID": "",
                    "dispachtCurrentStatus": 0,
                    "issues": "",
                    "dispachtStatusChangeDate": 0,
                    "historialOrder": 0
                    },
    }

    var history = []
const markerBytext ={
    lat: -33.4343419,
    lng: -70.6321369,
    markerName: "nombre Rider",
    urlPointMark: `static/images/markEbiex.png`,
    urlAvatarMark: `static/images/markEbiex.png`,
    telefono:'+56',
    time: new Date(),
}

const markerBytextB ={
  lat: -33.448595,
  lng: -70.669556,
  time: new Date(),
  urlPointMark: `/PointMark.svg`,
  urlAvatarMark: `/PointMark.svg`,
  markerName: "Punto B",
  telefono:'+56',
}

const markerBytextA ={
  lat: -33.4662886,
  lng: -70.6396216,
  time: new Date(),
  urlPointMark: `/PointMark.svg`,
  urlAvatarMark: `/PointMark.svg`,
  markerName: "Punto A",
  telefono:'+56',
}
var selectedName = ""
var selectedIco = ""

export default function Traking() {
 

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyDdHVO17wPYr1T9V3PP8zghn5Qfi2oPnJ0', libraries,  });

  const [markers, setMarkers] = React.useState([]);

  const [selected, setSelected] = React.useState(null);



  const[renderPoint,setRenderPoint] = React.useState(true);

  const [draggable, setDraggable] = React.useState(false)
  
  //const markerRef = useRef(null)
  const [condeDispacht, setcondeDispacht] = React.useState("")
  //const markerRef = useRef(null)

  const[errortrack,setErrortrack] = React.useState(null)

  const[sussestrack,setSussestrack] = React.useState(null)

  
  const[errorSinDato,setErrorSinDato] = React.useState('Ingrese un código de busqueda')

  const mapRef = React.useRef();

  const  eventHandlers = (latLng) => {
    //.onDragend{// console.log(latLng)}
    
  }


  React.useEffect(()=>{
// console.log(sussestrack)

  },[])

  const findOrderTraking = e => {
    // console.log('Click')
    setErrortrack(null)
    setSussestrack(null)
    if(!condeDispacht.trim()){
      // console.log('Debe ingresar un código')
      setErrortrack('Debe ingresar un código')

      return
    }
    encontrarOrden(condeDispacht)
  }
  const encontrarOrden = async (data) => {
    try{
      const response = await axios.get(`https://us-central1-e-biex-265f6.cloudfunctions.net/api/tracking/${data}`, { 
     // const response = await axios.get(`http://localhost:5000/e-biex-265f6/us-central1/api/tracking/${data}`, { 
                  headers: {
                            'Content-Type': 'application/json' 
                            }
                            });
                            //190604206
                            // console.log(response.data)
  
                            //// console.log((response.data[0]['dispacht']['courierDriverAvatar']))
                            if(response.data!=="No se encontraron coicidencias"){
                              
                            if(response.data[0]['courierDriverLocation']!==""){
                            markerBytext.urlAvatarMark=(response.data[0]['dispacht']['courierDriverAvatar'])
                            markerBytext.lat = (response.data[0]['dispacht']['courierDriverLocation']['_latitude'])
                            markerBytext.lng = (response.data[0]['dispacht']['courierDriverLocation']['_longitude'])
                            markerBytext.markerName = (response.data[0]['dispacht']['courierDriverName'])
                            markerBytext.telefono = (response.data[0]['dispacht']['courierDriverPhone'])
                            }
                           
                              // console.log(response.data[0]['dispacht']['courierDriverName'])
                              // console.log(response.data[0]['dispacht']['toAddress'])
                              // console.log(response.data[0]['dispacht']['toAdressComuna'])
                              // console.log(response.data[0]['dispacht']['toUserName'])
                           
                            markerBytextA.lat =(response.data[0]['dispacht']['toGeoNumAddressLat'])  
                            markerBytextA.lng =(response.data[0]['dispacht']['toGeoNumAddressLng']) 
                            markerBytextA.markerName = (response.data[0]['dispacht']['toUserName'])
                            markerBytextA.telefono = (response.data[0]['dispacht']['originAdressPhone'])

                              // console.log(response.data[0]['dispacht']['originAddress'])
                              // console.log(response.data[0]['dispacht']['originAdressComuna'])
                              // console.log(response.data[0]['dispacht']['originUserName'])
                            
                              
                            markerBytextB.lat =(response.data[0]['dispacht']['originGeoNumAddressLat'])  
                            markerBytextB.lng =(response.data[0]['dispacht']['originGeoNumAddressLng'])                            
                            markerBytextB.markerName = (response.data[0]['dispacht']['originUserName'])
                            markerBytextB.telefono = (response.data[0]['dispacht']['toAdressPhone'])
                                
                            // console.log(response.data[1]['history'])

                            history = response.data[1]['history'] 
                            
                            history.sort((a, b) => (a.dispachtStatusChangeDate < b.dispachtStatusChangeDate)?1:-1) ;

                            // console.log(history)

                            setSussestrack('Encontrado !')
                           setErrorSinDato(null)
                          }else{
                            setErrortrack('No encotramos este ID, verifique el código')
                            setErrorSinDato('Ingrese un código de busqueda')
                          }
    } catch (error) {
      // console.log(error)
    }
  }
  

  const onMapClick = React.useCallback((e) => {
      // console.log(e.latLng.lat())
      // console.log(e.latLng.lng())
      // setMarkers((current) => [
      //   ...current,
      //   {
      //     lat: e.latLng.lat(),
      //     lng: e.latLng.lng(),
      //     time: new Date(),
      //   },
      // ]);
    }, []);

  const ClearMap = React.useCallback((e) => {
    setMarkers(() => []);
  }, []);

   const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(14);
  }, []);

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  return (
    <div>
       <div id="mapsTracking">
        <h3>
          Sigue tus envíos con el ID de despacho.{" "} 
        </h3>
        {
          errortrack? (<div className="m-2"><span className="alert alert-warning">{errortrack}</span></div>):(<></>)
        }
        
        {
          sussestrack? (<div className="m-2"><span className="alert alert-success">{sussestrack}</span></div>):(<></>)
        }
        <br></br>
        <Form onSubmit={findOrderTraking}>
        <Form.Group widths='equal' >
              <Form.Field

                control={Input}
                type = "text"
                icon = 'search' 
                iconPosition='left'
                label='ingrese su código de seguimiento'
                onChange={e => setcondeDispacht(e.target.value)}
                value={condeDispacht}
        
              />
       </Form.Group>
       <Button  color="primary"  variant="contained"  type="sutmit"><TravelExploreIcon/>Traking</Button>
       </Form>
       {
         sussestrack? (<div className="m-2">
                        <div className="alert alert-success">Resumen:
                        
                        <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Código</th>
                            <th scope="col">{condeDispacht}</th>
                       
                     
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">Envia</th>
                            <td>{markerBytextA.markerName}</td>
                       
                   
                          </tr>
                          <tr>
                            <th scope="row">Recibe</th>
                            <td>{markerBytextB.markerName}</td>
                                           
                          </tr>
                        </tbody>
                      </table>
                      </div>
                      <div className="alert alert-info">Historial
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Fecha</th>
                            <th scope="col">Estado</th>
                       
                     
                          </tr>
                        </thead>
                        
                        <tbody>
                        {history.map((historyMk) => (
                          <tr key={historyMk.id}>
                            <th  scope="row">{format(historyMk.dispachtStatusChangeDate, 'dd/MM/yy')}
                            </th>
                            <td>{historyMk.issues}</td>
                            </tr>
                            ))}

                        </tbody>
                      </table>
                        
                        </div>
                       </div>):(<div></div>)
       }
    </div>
    <Container className="bodycontent">
    <GoogleMap
        id="mapControl"
        mapContainerStyle={mapContainerStyle}
        zoom={13}
        center={center}
        options={options}
        onClick={onMapClick}
        onLoad={onMapLoad}
      > 
        {
          errorSinDato? (<div id="mapalert" className="m-2"><span className="alert alert-info">{errorSinDato}</span></div>):(
        <>
        {LoadMarketA(selected,setSelected,draggable,eventHandlers,setMarkers,selectedName)}
        {LoadMarketB(selected,setSelected,draggable,eventHandlers,setMarkers,selectedName)}
        {LoadMarket(selected,setSelected,draggable,eventHandlers,setMarkers,selectedName)} 
        </> 
        )
        }
      
        {
        markers.map((marker) => (         
          <Marker
          onDragEnd = {(e) => {      
            // console.log(e.latLng)
            // console.log(e.latLng.lat())
            // console.log(e.latLng.lng())
            marker.lat= e.latLng.lat()  
            marker.lng= e.latLng.lng()
          }}
          draggable={true}
            key={`${marker.lat}-${marker.lng}`}
            position={{ lat: marker.lat, lng: marker.lng }}
            onClick={() => {
              setSelected(marker);
         
            }}
            icon={{
              url: markers.urlPointMark,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              scaledSize: new window.google.maps.Size(50, 50),
            }}
          />
          
        ))
        
        }
        {selected ? (
                  <InfoWindow
                    position={{ lat: selected.lat, lng: selected.lng }}
                    onCloseClick={() => {
                      setSelected(null);
                    }}
                  >
                    <div>
                      <h2>
                        <span role="img" aria-label="BICCI EXPRESS">
                        <img id="icono-ebiex" src={selected.urlAvatarMark}  />
                        </span>{" "}
                      
                      </h2>
                      <p>{selected.markerName}</p>
                      <p>Telf:{selected.telefono}</p>
                    </div>
                  </InfoWindow>
                ) : null} 
      </GoogleMap>
      </Container>
    </div>
  );
}

function Locate({ panTo  }) {
  return (
    <button
      className="locate btn-primary m-1"
      onClick={() => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            panTo({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          () => null
        );
      }}
    >
      <ShareLocationIcon></ShareLocationIcon>Encuentrame
    </button>
  );
}

function Search({ panTo  }) {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions, 
    
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 43.6532, lng: () => -79.3832 },
      radius: 10 * 1000,
      searchOptions : {
        componentRestrictions: {
          country: "Cl"}
      }
    },
    
  
  });
  // https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest
  const handleInput = (e) => {
    setValue(e.target.value);
  };
  const handleSelect = async (address) => {
    // console.log(address)
    setValue(address, false);
    clearSuggestions();
    let element=[]
    try {
      const results = await getGeocode({ address });
      // // console.log(results[0].address_components[0].long_name);
      // // console.log(results[0].address_components[1].long_name);
      // // console.log(results[0].address_components[2].long_name);
      // // console.log(results[0].address_components[3].long_name);
      // // console.log(results[0].address_components[4].long_name);
      // // console.log(results[0].address_components[5].long_name);
      // // console.log(results[0].address_components[6].long_name);
      // console.log(results[0])
      // console.log(results[0].address_components.length)
      
      const { lat, lng } = await getLatLng(results[0]);
      panTo({ lat, lng });
    //  si funcion
       markerBytext.lat= lat;
       markerBytext.lng=lng;
      // console.log(lat);
      // console.log(lng);

    } catch (error) {
      // console.log("😱 Error: ", error);
      // console.log(element)
    }
  };

  return (
    <div className="search">
      <Combobox 
        onSelect={handleSelect}
        >
        <ComboboxInput
        className="input-group mb-3"
        id="input-ebiex-maps"
          value={value}
          onChange={handleInput}
          disabled={!ready}
          placeholder="Busca tu ubicación"
          

        />
        <ComboboxPopover className="comboboxList-ebiex" >
          <ComboboxList >
            {status === "OK" &&
              data.map(({ id, description }) => (
                <ComboboxOption key={id} value={description} className="dropdown-item dropdown-ebiex"/>
              ))
              
              }
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
      
    </div>
  );
}

function LoadMarket(selected,setSelected,setMarkers){
return (
  <>
  <Marker
  onDragEnd = {(e) => {
    markerBytext.lat= e.latLng.lat();
    markerBytext.lng= e.latLng.lng();
   
    // console.log(e.latLng)
    // console.log(e.latLng.lat())
    // console.log(e.latLng.lat())
  }}
  draggable={false}

  key={`${markerBytext.lat}-${markerBytext.lng}`}
  position={{ lat: markerBytext.lat, lng: markerBytext.lng }}
    icon={{
      url: markerBytext.urlPointMark,
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(15, 15),
      scaledSize: new window.google.maps.Size(35, 50),
    }}
    onClick={() => {
      setSelected(markerBytext);
    }}

    onChange={()=>{
      setSelected({ lat: markerBytext.lat, lng: markerBytext.lng });
     // setMarkers({ lat: markerBytext.lat, lng: markerBytext.lng })
    }}
  
  />


  </>
)
}

function LoadMarketA(selected,setSelected,setMarkers){
  return (
    <>
    <Marker 
    key={`${markerBytextA.lat}-${markerBytextA.lng}`}
    position={{ lat: markerBytextA.lat, lng: markerBytextA.lng }}
    icon={{
        url: markerBytextA.urlPointMark,
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(15, 15),
        scaledSize: new window.google.maps.Size(50, 50),
      }}
    onClick={() => {
        setSelected(markerBytextA);
      }}
  
      onChange={()=>{
        setSelected({ lat: markerBytextA.lat, lng: markerBytextA.lng });
       // setMarkers({ lat: markerBytext.lat, lng: markerBytext.lng })
      }}
    
    />
  {
  // console.log(selected)
  }
  {
  // console.log(selectedName)
  }
    </>
  )
  }
  
function LoadMarketB(selected,setSelected,setMarkers){
  return (
      <>
      <Marker 
      key={`${markerBytextB.lat}-${markerBytextB.lng}`}
      position={{ lat: markerBytextB.lat, lng: markerBytextB.lng }}
      icon={{
          url: markerBytextB.urlPointMark,
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(15, 15),
          scaledSize: new window.google.maps.Size(50, 50),
        }}
      onClick={() => {     
          setSelected(markerBytextB);
        }}
    
        onChange={()=>{
          setSelected({ lat: markerBytextB.lat, lng: markerBytextB.lng });
         // setMarkers({ lat: markerBytext.lat, lng: markerBytext.lng })
        }}
      
      />
  {
  // console.log(selected)
  }
  {
  // console.log(selectedName)
  }
      </>
    )
    }  




